import { OverlayTrigger, Tooltip } from 'react-bootstrap';

type PageHeaderProps = {
  onBackClick: () => void;
  title: string;
  description?: string;
  onOptionClick?: () => void;
  optionIcon?: string;
  optionPlaceHolder?: string;
};
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const PageHeader: React.FunctionComponent<PageHeaderProps> = (props) => {
  return (
    <>
      <header className='header bg-base text-light d-flex'>
        <div onClick={props.onBackClick} className='p-1 px-md-2 d-flex align-items-center cup'>
          <span className='mdi mdi-36px mdi-chevron-right lh-1'></span>
        </div>
        <div className='align-items-center align-items-md-start d-flex flex-column justify-content-center flex-grow-1 py-25'>
          <span className='fw-bold header-title'>{props.title}</span>
          <span className='opacity-50'>{props.description}</span>
        </div>
        <div className='p-2 px-md-3 d-flex align-items-center cup'>
          {props.optionIcon && props.onOptionClick ? (
            <>
              {props?.optionPlaceHolder ? (
                <OverlayTrigger
                  placement='bottom'
                  overlay={
                    <Tooltip id='tooltip' aria-disabled={isMobile}>
                      <strong>{props?.optionPlaceHolder}</strong>
                    </Tooltip>
                  }
                >
                  <span
                    onClick={() => props.onOptionClick?.()}
                    className={`mdi mdi-24px ${props.optionIcon} lh-1`}
                  ></span>
                </OverlayTrigger>
              ) : (
                <span
                  onClick={() => props.onOptionClick?.()}
                  className={`mdi mdi-24px ${props.optionIcon} lh-1`}
                ></span>
              )}
            </>
          ) : (
            <span className={'mdi mdi-24px mdi-blank lh-1'}></span>
          )}
        </div>
      </header>
    </>
  );
};

export default PageHeader;
